module.exports = __webpack_public_path__ + "static/media/patrick-maccory-200x200.a4cf5914.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/page/company/advisors/images/patrick-maccory-200x200.jpg
// module id = 1776
// module chunks = 147